var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.814,
    height: 29.814,
    viewBox: "0 0 29.814 29.814",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pause",
    transform: "translate(-0.001 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_57545",
    "data-name": "Path 57545",
    d: "M25.446,4.368a14.9,14.9,0,1,0,0,21.077A14.9,14.9,0,0,0,25.446,4.368ZM14.908,27.362A12.455,12.455,0,1,1,27.363,14.907,12.469,12.469,0,0,1,14.908,27.362Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57546",
    "data-name": "Path 57546",
    d: "M278.614,160.057a1.224,1.224,0,0,0-1.224,1.224v8.705a1.224,1.224,0,0,0,2.448,0v-8.705A1.224,1.224,0,0,0,278.614,160.057Z",
    transform: "translate(-261.22 -150.727)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57547",
    "data-name": "Path 57547",
    d: "M193.281,160.057a1.224,1.224,0,0,0-1.224,1.224v8.705a1.224,1.224,0,0,0,2.448,0v-8.705A1.224,1.224,0,0,0,193.281,160.057Z",
    transform: "translate(-180.861 -150.727)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.5f98665dd4723f1be532bf4a9d35e86b.svg";
export { ForwardRef as ReactComponent };